import {Component, Input, OnDestroy, inject} from '@angular/core';
import {Subscription} from 'rxjs';
import {TextSanitizerPipe} from '@xmedical/core';
import {CoreService} from '../../../../core/services/core.service';
import {TreatmentPlanItem, Patient} from '@xmedical/core';
import {PatientStore, PatientTreatmentPlanItemsStore} from '../../../../core/state';

@Component({
    selector: 'app-treatment-plan-action-item',
    templateUrl: './treatment-plan-action-item.component.html',
    styleUrls: ['./treatment-plan-action-item.component.scss'],
    standalone: false
})
export class TreatmentPlanActionItemComponent implements OnDestroy {

  private treatmentPlanSubscription: Subscription;
  error = '';
  loading = false;
  @Input() item: TreatmentPlanItem;
  @Input() usePrimaryText = false;

  private patientStore = inject(PatientStore);
  private itemsStore = inject(PatientTreatmentPlanItemsStore);

  constructor(
    private coreService: CoreService,
    private textSanitizePipe: TextSanitizerPipe) { }

  ngOnDestroy(): void {
    if (this.treatmentPlanSubscription) { this.treatmentPlanSubscription.unsubscribe(); }
  }

  get patient(): Patient | null {
    return this.patientStore.current();
  }

  get confirmationMessage(): string {
    const sanitized = this.textSanitizePipe.transform(this.item.action.substr(0, 50));
    if (!this.patient) {
      return `Are you sure you want to remove ${sanitized}...?`;
    }
    return `Are you sure you want to remove ${sanitized}... from ${this.patient.firstName} ${this.patient.surname}?`;
  }

  removeTreatmentPlanItemFromPatient(treatmentPlanItemId: number) {
    this.loading = true;
    this.error = '';
    this.treatmentPlanSubscription = this.itemsStore.remove(treatmentPlanItemId).subscribe({
      next: () => this.loading = false,
      error: error => {
        this.error = error;
        this.coreService.showErrorToast(error);
        this.loading = false;
      }
    });
  }
}
